import React, { FC } from 'react';
import './Controls.style.css';

import Toggle from 'react-toggle';

import {
  Button,
  ButtonsContainer,
  ControlsContainer,
  ToggleContainer,
  ToggleSectionContainer,
} from './Controls.style';

interface ControlsProps {
  segmentations: any;
  activeSegmentation: any;
  useOpenContours: boolean;
  setUseOpenContours: (value: (prev: boolean) => boolean) => void;
  setActiveSegmentation: (segmentation: any) => void;
  showOtherSegmentations: boolean;
  setShowOtherSegmentations: (value: (prev: boolean) => boolean) => void;
  showSegmentationPredictions: boolean;
  showSegmentationReferences: boolean;
  adoptSegmentation: () => void;
  editMode: boolean;
  setActiveOtherSegmentationClasses: (value: (prev: any) => any) => void;
}

const Controls: FC<ControlsProps> = ({
  segmentations,
  activeSegmentation,
  useOpenContours,
  setUseOpenContours,
  setActiveSegmentation,
  showOtherSegmentations,
  setShowOtherSegmentations,
  showSegmentationPredictions,
  showSegmentationReferences,
  adoptSegmentation,
  editMode,
  setActiveOtherSegmentationClasses,
}) => {
  const handleToggleOpenContours = () => {
    if (editMode) return;
    setUseOpenContours(useOpenContours => !useOpenContours);
  };
  const handleToggleShowOtherSegmentations = () => {
    if (editMode) return;
    const next = !showOtherSegmentations;

    if (next)
      setActiveOtherSegmentationClasses(() => {
        const labeledClasses = segmentations
          .filter((segmentation: any) => !!segmentation.paths)
          .map((segmentation: any) => segmentation.segmentationClassValue);
        return labeledClasses;
      });
    setShowOtherSegmentations(showOtherSegmentations => !showOtherSegmentations);
  };

  const handleDeleteOnClick = () => {
    if (editMode) return;
    setActiveSegmentation({
      ...activeSegmentation,
      isLabeled: false,
      paths: [],
      sourceType: null,
      sourceUuid: null,
    });
  };

  return (
    <ControlsContainer editMode={editMode}>
      <ToggleSectionContainer>
        <ToggleContainer onClick={handleToggleOpenContours}>
          <div style={{ color: '#fff' }}>Use Open Contours</div>
          <Toggle checked={useOpenContours} onClick={handleToggleOpenContours} readOnly />
        </ToggleContainer>
      </ToggleSectionContainer>
      <ToggleSectionContainer>
        <ToggleContainer onClick={handleToggleShowOtherSegmentations}>
          <div style={{ color: '#fff' }}>Show segmentations from other features</div>
          <Toggle
            checked={showOtherSegmentations}
            onClick={handleToggleShowOtherSegmentations}
            readOnly
          />
        </ToggleContainer>
      </ToggleSectionContainer>

      {(showSegmentationPredictions || showSegmentationReferences) && (
        <ToggleSectionContainer>
          <ButtonsContainer>
            <Button disabled={editMode} green fullWidth onClick={adoptSegmentation}>
              Adopt {showSegmentationReferences ? 'Reference' : 'Prediction'}
            </Button>
          </ButtonsContainer>
        </ToggleSectionContainer>
      )}
      <ToggleSectionContainer>
        <ButtonsContainer>
          <Button disabled={editMode} onClick={handleDeleteOnClick}>
            Delete
          </Button>
        </ButtonsContainer>
      </ToggleSectionContainer>
    </ControlsContainer>
  );
};

export default Controls;
